// src/sections/WechselrichterSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, Grid, Input, Button, VStack } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function WechselrichterSection({ selectedAnlageId }) {
  const [wechselrichter, setWechselrichter] = useState([
    { hersteller: "", type: "", leistung: "", anzahl: "" },
  ]);
  const [herstellerList, setHerstellerList] = useState([]);

  // ✅ LOAD existing data
useEffect(() => {
  if (!selectedAnlageId) return;

  axios
    .get(`${process.env.REACT_APP_API_URL}/api/wechselrichter/anlage/${selectedAnlageId}`)
    .then((res) => {
      setWechselrichter(
        res.data.length
          ? res.data
          : [{ hersteller: "", type: "", leistung: "", anzahl: "" }]
      );
    })
    .catch(() => {
      setWechselrichter([{ hersteller: "", type: "", leistung: "", anzahl: "" }]);
    });
}, [selectedAnlageId]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
      .then((res) => setHerstellerList(res.data))
      .catch((err) => console.error("Error loading Hersteller:", err));
  }, []);

  const handleSave = async () => {
    try {
      const filled = wechselrichter.filter(
        (w) => w.hersteller && (w.type || w.leistung || w.anzahl)
      );
      for (const wr of filled) {
        if (wr.id) {
          await axios.put(`${process.env.REACT_APP_API_URL}/api/wechselrichter/${wr.id}`, {
            ...wr,
            anlage: { id: selectedAnlageId },
          });
        } else {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/wechselrichter`, {
            ...wr,
            anlage: { id: selectedAnlageId },
          });
        }
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/wechselrichter/anlage/${selectedAnlageId}`
      );
      setWechselrichter(res.data);
      showSuccess("Erfolg!", "Wechselrichter gespeichert oder aktualisiert.");
    } catch {
      showError("Fehler!", "Speichern fehlgeschlagen.");
    }
  };

  const handleDelete = async (id) => {
    await axios.delete(`${process.env.REACT_APP_API_URL}/api/wechselrichter/${id}`);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...wechselrichter];
    updated[index][name] = value;
    setWechselrichter(updated);
  };

  const addRow = () =>
    setWechselrichter((prev) => [
      ...prev,
      { hersteller: "", type: "", leistung: "", anzahl: "" },
    ]);

  const removeRow = (index) =>
    setWechselrichter((prev) => prev.filter((_, i) => i !== index));

  return (
      <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="fit-content"
    >
      <Heading fontSize="21px" mb={6} color="black.600">
        WECHSELRICHTER
      </Heading>

      <VStack spacing={4} align="stretch">
        {wechselrichter.map((w, index) => (
          <Grid
            key={index}
            templateColumns="repeat(4, 1fr) 60px"
            gap={4}
            alignItems="center"
            bg="gray.50"
            p={4}
            rounded="lg"
          >
            <select
              name="hersteller"
              value={w.hersteller}
              onChange={(e) => handleChange(index, e)}
            >
              <option value="">Hersteller wählen</option>
              {herstellerList.map((h) => (
                <option key={h.id} value={h.name}>
                  {h.name}
                </option>
              ))}
            </select>

            <Input
              name="type"
              placeholder="Typ"
              value={w.type}
              onChange={(e) => handleChange(index, e)}
            />
            <Input
              name="leistung"
              placeholder="Leistung (kW)"
              value={w.leistung}
              onChange={(e) => handleChange(index, e)}
            />
            <Input
              name="anzahl"
              placeholder="Anzahl"
              value={w.anzahl}
              onChange={(e) => handleChange(index, e)}
            />

            <Button
               bg="#B22222" // Firebrick red (similar depth to your gold)
              color="white"
              _hover={{ bg: "#D22B2B" }} // Slightly lighter red on hover
              size="md"
              width="fit-content"
              onClick={() => {
                removeRow(index);
                if (w.id) handleDelete(w.id);
              }}
            >
              Löschen
            </Button>
          </Grid>
        ))}

        <Button  
          bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          size="md"
           onClick={addRow}>
          + Neuer Wechselrichter
        </Button>

        <Button 
          bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          fontSize="md"
          onClick={handleSave}>
          Speichern Wechselrichter
        </Button>
      </VStack>
    </Box>
  );
}